import { render } from "./MultipleBillingEmails.vue?vue&type=template&id=4631d7fa&scoped=true"
import script from "./MultipleBillingEmails.vue?vue&type=script&lang=js"
export * from "./MultipleBillingEmails.vue?vue&type=script&lang=js"

import "./MultipleBillingEmails.vue?vue&type=style&index=0&id=4631d7fa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4631d7fa"]])

export default __exports__